import { ASM_FEATURE } from '@asm/const';
import { createFeatureSelector, MemoizedSelector } from '@ngrx/store';
import { AsmState, StateWithAsm } from '../asm-state';

export const getAsmState: MemoizedSelector<StateWithAsm, AsmState> = createFeatureSelector<AsmState>(ASM_FEATURE);
